
					<div class="row">
              <div class="col col-login mx-auto card p-6">
                <div class="text-center mb-4 ">
                  <span class="avatar avatar-xxl  brround" style="background-image: url(assets/images/faces/female/25.jpg)"></span>
                </div>
                <span class="m-4 d-none d-lg-block text-center">
                  <span class="text-dark"><strong>Sindy Scribner</strong></span>
                </span>
                <div class="form-group">
                  <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password">
                </div>
                <a href="" class="btn btn-primary btn-block">Unlock</a>
  
              </div>
            </div>
          